// components/MobileDrawer/MobileDrawer.jsx
import React, { useState } from "react";
import "./MobileDrawer.css";
import { useAuth } from "../../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { API_BASE_URL } from "../../utils/apiUrl";
import ConfirmModal from "../modals/ConfirmModal/ConfirmModal";
import { getImageSrc } from "../../utils/getImageSrc";

const MobileDrawer = ({
  isOpen,
  onClose,
  notificationCount = 0,
  isAuthenticated = false,
  onOpenNotifications, // ← called when user taps Notifications
}) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const displayName = user
    ? user.academyName || `${user.firstName} ${user.lastName}`
    : "Guest";

  // console.log("display name", displayName);

  const avatarSrc = getImageSrc(user?.picture);

  const roleLabel =
    user?.role === "institution"
      ? "Training Center"
      : user?.role === "tutor"
        ? "Tutor"
        : user?.role === "student"
          ? "Student"
          : "";

  const homeRoute =
    user?.role === "student"
      ? "/student-home"
      : user?.role === "tutor"
        ? "/tutor-home"
        : user?.role === "institution"
          ? "/academy-home"
          : "/";

  const confirmLogout = () => {
    logout();
    navigate("/");
    setShowLogoutModal(false);
  };

  const handleNotificationsClick = (e) => {
    e.preventDefault();
    e.stopPropagation(); // prevent event bubbling to document listeners

    onClose(); // close the drawer

    // Delay opening the panel so the drawer's close animation finishes
    // and the modal's outside-click listener isn't set up yet when the
    // original tap event finishes propagating.
    setTimeout(() => {
      onOpenNotifications?.();
    }, 200);
  };

  return (
    <>
      <div className={`mobile-drawer ${isOpen ? "open" : ""}`}>
        <div className="drawer-header">
          <div className="user-profile">
            <img src={avatarSrc} alt={displayName} className="user-avatar" />
            <div>
              <h3>{displayName}</h3>
              <p className="user-role-mobile">{roleLabel}</p>
            </div>
          </div>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        {user ? (
          <nav className="drawer-nav authenticated">
            <a href={homeRoute} onClick={onClose}>
              Home
            </a>
            <a href={`/account`} onClick={onClose}>
              My Account
            </a>
            <a
              href="#notifications"
              onClick={handleNotificationsClick}
              className="drawer-nav-notif"
            >
              Notifications
              {notificationCount > 0 && (
                <span className="drawer-badge">
                  {notificationCount > 99 ? "99+" : notificationCount}
                </span>
              )}
            </a>
            {/* <a href="/blog" onClick={onClose}>
              Blog
            </a> */}
            <a href="/about-us" onClick={onClose}>
              About Us
            </a>
            <a href="/get-help" onClick={onClose}>
              Help Desk
            </a>
            <a onClick={() => setShowLogoutModal(true)}>Logout</a>
          </nav>
        ) : (
          <>
            <nav className="drawer-nav">
              <a href="/" onClick={onClose}>
                Home
              </a>
              {/* <a href="/blog" onClick={onClose}>
                Blog
              </a> */}
              <a href="/about-us" onClick={onClose}>
                About Us
              </a>
              <a href="/get-help" onClick={onClose}>
                Get Help
              </a>
            </nav>
            <div className="drawer-auth">
              <a
                href="/decision-screen"
                className="btn-primary"
                onClick={onClose}
              >
                Create Account
              </a>
              <a href="/login" className="btn-outline" onClick={onClose}>
                Login
              </a>
            </div>
          </>
        )}

        <div className="mobile-drawer-footer">
          <img src="/images/tutorslinks.png" alt="TutorsLinks" />
        </div>
      </div>

      {isOpen && <div className="drawer-overlay" onClick={onClose}></div>}

      <ConfirmModal
        isOpen={showLogoutModal}
        title="Logout"
        message="Are you sure you want to logout?"
        onConfirm={confirmLogout}
        onCancel={() => setShowLogoutModal(false)}
      />
    </>
  );
};

export default MobileDrawer;
